/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signedoutsuccessfully2Inputs */

const en_signedoutsuccessfully2 = /** @type {(inputs: Signedoutsuccessfully2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed out successfully`)
};

const de_signedoutsuccessfully2 = /** @type {(inputs: Signedoutsuccessfully2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfolgreich abgemeldet`)
};

/**
* | output |
* | --- |
* | "Signed out successfully" |
*
* @param {Signedoutsuccessfully2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signedoutsuccessfully2 = /** @type {((inputs?: Signedoutsuccessfully2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signedoutsuccessfully2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signedoutsuccessfully2(inputs)
	return de_signedoutsuccessfully2(inputs)
});
export { signedoutsuccessfully2 as "signedOutSuccessfully" }